export default __webpack_public_path__ + "static/media/heart.d555a882.svg";